export const GIGSKY_LINK = 'https://plans.gigsky.com/GZHPZ/2CTPL/';
